import React from 'react';
import {Provider} from 'react-redux';
import ReactGA4 from 'react-ga4';
import AppAdopta from './App/AppAdopta';
import configSentry from "./scripts/configSentry.js"
import '../public/vendors/bootstrap/v4.0.0/css/bootstrap.min.css';
import '../public/fonts/lineawesome/1.3.0/css/line-awesome.min.css';
import '../public/css/style-modal.min.css';
import '../public/css/style.css'
import '../public/css/theme-adopta.css'
import configStore from './App/reducers';
import {createRoot} from "react-dom/client";
import {BrowserRouter} from 'react-router-dom';

if (process.env.NODE_ENV === 'production' && (process.env.DEV_ENV === 'DEMO' || process.env.DEV_ENV === 'PRO')){
    if (process.env.GOOGLE_ANALYTICS_4_TAG_ID) ReactGA4.initialize(process.env.GOOGLE_ANALYTICS_4_TAG_ID);
}

configSentry()

const store = configStore().store
const persistor = configStore().persistor
const root = createRoot(
    document.getElementById('root')
);

export const router = (
    <BrowserRouter history={history}>
        <Provider store={store}>
            <AppAdopta store={store} persistor={persistor}/>
        </Provider>
    </BrowserRouter>
);
root.render(router);
// root.render(<React.StrictMode>{router}</React.StrictMode>);
